export default __webpack_public_path__ + "static/media/no_fee_calendar_placeholder.737944d1.svg";